import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setFilterModel } from "../../data/redux/filterSlice";

const NavigationListener = () => {
  const dispatch = useDispatch();
  const location = useLocation(); // Detect route changes

  useEffect(() => {
    // Clear filterModel on route change
    dispatch(setFilterModel({ items: [] }));
  }, [location.pathname, dispatch]);

  return null; // This component does not render anything
};

export default NavigationListener;
